// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const MultipleRunWorkspace = styled.div`
  display: flex;
  flex-grow: 1;
  z-index: 0;

  .auto-vis-controls {
    display: inline-flex;
    align-items: center;
    margin-left: 16px;
  }

  .chart-search {
    margin-right: 12px;
    min-width: 240px;
  }

  @media only screen and (max-width: @tabletBreakpoint) {
    .project-page {
      .project-page-workspace {
        .chart-search {
          min-width: 180px;
          width: 180px;
        }
      }
    }
  }
`;
MultipleRunWorkspace.displayName = 'S.MultipleRunWorkspace';
